
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface UploadButtonProps {
  uploading: boolean;
  onUploadClick: () => void;
}

export const UploadButton = ({ uploading, onUploadClick }: UploadButtonProps) => {
  return (
    <div>
      <Button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onUploadClick();
        }}
        disabled={uploading}
        variant="secondary"
        className="w-full relative hover:bg-white/20 cursor-pointer"
      >
        {uploading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Wird hochgeladen...
          </>
        ) : (
          'Bild auswählen'
        )}
      </Button>
      <p className="text-sm text-gray-300 mt-2">
        Maximale Dateigröße: 5MB. Erlaubte Formate: JPG, PNG, GIF
      </p>
    </div>
  );
};
